import * as React from 'react';
import styles from './HeaderSlogan.module.css'; // Import css modules stylesheet as styles

const HeaderSlogan = (props) => {
    return (

        <div className={styles.header }>Simple. Safe. Can & Bottle Recycling Service</div>
    )
}

export default HeaderSlogan;